import {
  GET_PROPERTY_STATUSES,
  GET_PROPERTY_STATUSES_RESPONSE,
  RESET,
} from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  data: {
    propertyStatusesList: {
      items: [],
    },
    searchQuery: null,
    range: { start: 0, end: 25 },
  },
};

// State
export default (state = initialState, action) => {
  var data = state.data;
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);
    case GET_PROPERTY_STATUSES:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_PROPERTY_STATUSES_RESPONSE:
      data.propertyStatusesList.items = action.propertyStatuses;
      return {
        ...state,
        data: data,
        error: action.error,
        isLoading: false,
      };
    default:
      return {
        ...state,
      };
  }
};
